var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goog-map" },
    [
      _vm.getGmapAPIKey
        ? _c(
            "GmapMap",
            {
              ref: "baseMap",
              style: "width: " + _vm.width + "; height: " + _vm.height + ";",
              attrs: {
                options: {
                  mapTypeControlOptions: { mapTypeIds: [] },
                  disableDefaultUI: true
                },
                center: _vm.getCenter(),
                zoom: _vm.zoom
              }
            },
            [
              _vm._l(_vm.locations, function(resturantLocation) {
                return _c(
                  "div",
                  { key: resturantLocation.id },
                  [
                    !_vm.directions && _vm.googleLoaded
                      ? _c("google-marker-info-window", {
                          attrs: {
                            location: resturantLocation,
                            icon: _vm.icons.destination,
                            pixelOffset: _vm.getPixelOffset(),
                            focusedLocationBase: _vm.getFocusedLocationBase()
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleMarkerInfoClick(
                                resturantLocation
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.directions && _vm.googleLoaded && _vm.storeLocation
                ? _c("google-marker-info-window", {
                    attrs: {
                      location: _vm.storeLocation,
                      icon: _vm.getMarkerIcon(),
                      pixelOffset: _vm.getPixelOffset(),
                      focusedLocationBase: _vm.getFocusedLocationBase()
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.emit("click")
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c5e8317", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5e8317","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseMap.vue
// module id = null
// module chunks = 